
import NoMore from '../components/noMore.vue'
import { createElement } from '../utils/formatter'
import { debounce } from 'lodash'

export default {
  data() {
    return {
      noMoreEl: null,
      containerEl: null,
      noMoreElId: 'aggrid-no-more',
      noMoreTopId: 'aggrid-no-more-top',
      nooMoreTopEl: null,
      toastText: '',
      displayToastMessage: false
    }
  },
  methods: {
    showToastMessage: function(message, timeout = 2000) {
      this.toastText = message
      if (!this.displayToastMessage) {
        this.displayToastMessage = true
      }
      if (typeof timeout === 'number' && timeout > 0) {
        setTimeout(() => {
          this.displayToastMessage = false
        }, timeout)
      }
    },
    bodyScrollEnd: debounce(function(e) {
      if (!this.map.isPagination) {
        const agGrid = this.$refs[this.agGridID]
        const [agBodyViewPort] = agGrid.$el.getElementsByClassName('ag-body-viewport')
        const maxScrollBottom = agBodyViewPort.scrollHeight - agBodyViewPort.clientHeight

        if (Math.ceil(e.top) === maxScrollBottom && e.direction === 'vertical' && this.scrollNoMore) {
          if (this.map.bottomListStrategy.toast) {
            this.showToastMessage(this.map.bottomListStrategy.toastMessage || `You are at the bottom`)
          }
          else {
            this.noMore()
          }
        }

        if (e.top === 0 && e.direction === 'vertical' && this.map.topListStrategy && !this.loading) {
          if (!this.nooMoreTopEl && this.map.topListStrategy.inject) {
            this.nooMoreTopEl = createElement(NoMore, {
              props: {
                message: this.map.topListStrategy.injectMessage || 'No More top'
              },
              attrs: {
                id: 'aggrid-no-more-top'
              }
            })
          }
          const [container] = agGrid.$el.getElementsByClassName('ag-center-cols-container')
          const noMoreExist = container.querySelector(`#${this.noMoreTopId}`)
          if (!noMoreExist && this.map.topListStrategy.inject) {
            this.$nextTick(() => {
              container.prepend(this.nooMoreTopEl)

              setTimeout(() => {
                container.removeChild(this.nooMoreTopEl)
              }, 2000)
            })
          }

          if (this.map.topListStrategy.toast) {
            this.showToastMessage(this.map.topListStrategy.toastMessage || `You are at the top`)
          }
        }
      }
    }, 250),
    noMore() {
      const agGrid = this.$refs[this.agGridID]

      if (agGrid && this.map.bottomListStrategy && this.map.bottomListStrategy.inject) {
        const [containerClipper] = agGrid.$el.getElementsByClassName('ag-center-cols-clipper')

        this.$nextTick(() => {
          const currentHeight = +containerClipper.style.height.replace(/[^0-9]/g, '')

          if (currentHeight) {
            containerClipper.style.height = `${currentHeight + 42}px`
          }
          const injectMessage = this.map.bottomListStrategy.injectMessage
          const templateContext = {
            start: this.start,
            limit: this.limit,
            total: this.rowCount
          }

          this.noMoreEl = createElement(NoMore, {
            props: {
              ...(injectMessage && injectMessage.length && { message: injectMessage, context: templateContext })
            },
            attrs: {
              id: 'aggrid-no-more'
            },
            style: {
              transform: `translateY(${currentHeight}px)`,
              height: '42px',
              top: '15px'

            }
          })
          const [container] = agGrid.$el.getElementsByClassName('ag-center-cols-container')
          this.containerEl = container
          this.containerEl.appendChild(this.noMoreEl)
          setTimeout(() => {
            const noMoreExist = this.containerEl.querySelector(`#${this.noMoreElId}`)
            if (noMoreExist) {
              this.containerEl.removeChild(noMoreExist)
              const currentHeight = +containerClipper.style.height.replace(/[^0-9]/g, '')
              containerClipper.style.height = `${currentHeight - 42}px`
            }
          }, 2000)
        })
      }
    },
    loaded() {
      if (this.containerEl) {
        const noMoreExist = this.containerEl.querySelector(`#${this.noMoreElId}`)
        if (noMoreExist) {
          this.containerEl.removeChild(noMoreExist)
        }
      }
    }
  }
}
